// extracted by mini-css-extract-plugin
module.exports = {"root":"WaDCfD3","list":"_2wgCYI-","listOpen":"PZdHQ7J"};